import * as types from './actionTypes';
import { api } from './api';
import moment from 'moment';

export function updateSystemInfoMessage(infoMessage) {
	return api({
		types: [types.ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_REQUEST, types.ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_SUCCESS, types.ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_FAILURE],
		uri: '/api/admin/systeminfo',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(infoMessage),
		},
		payload: { infoMessage },
	});
}

export function fetchAdminState() {
	return api({
		types: [types.ADMIN__FETCH_ADMIN_STATE_REQUEST, types.ADMIN__FETCH_ADMIN_STATE_SUCCESS, types.ADMIN__FETCH_ADMIN_STATE_FAILURE],
		uri: '/api/admin',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
		payload: {},
	});
}

export function searchUsers(search) {
	return api({
		types: [types.ADMIN__SEARCH_USERS_REQUEST, types.ADMIN__SEARCH_USERS_SUCCESS, types.ADMIN__SEARCH_USERS_FAILURE],
		uri: '/api/admin/search',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(search),
		},
		payload: search,
	});
}

export function updateStaffVerificationRequest(requestData) {
	return api({
		types: [types.ADMIN__UPDATE_STAFF_VERIFY_REQUEST, types.ADMIN__UPDATE_STAFF_VERIFY_SUCCESS, types.ADMIN__UPDATE_STAFF_VERIFY_FAILURE],
		uri: '/api/admin/staffVerifications',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(requestData),
		},
		payload: { requestData },
	});
}

export function loginAsUser(userId) {
	return api({
		types: [types.ADMIN__LOGIN_AS_USER_REQUEST, types.ADMIN__LOGIN_AS_USER_SUCCESS, types.ADMIN__LOGIN_AS_USER_FAILURE],
		uri: '/api/admin/impersonate',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ id: userId }),
		},
		payload: { id: userId },
	});
}

export function fetchPendingStaffVerifications() {
	return api({
		types: [types.ADMIN__FETCH_STAFF_VERIFY_REQUEST, types.ADMIN__FETCH_STAFF_VERIFY_SUCCESS, types.ADMIN__FETCH_STAFF_VERIFY_FAILURE],
		uri: '/api/admin/staffVerifications',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
		payload: {},
	});
}

export function updateChatOptionsRequest(requestData) {
	return api({
		types: [types.ADMIN__UPDATE_CHAT_OPTIONS_REQUEST, types.ADMIN__UPDATE_CHAT_OPTIONS_SUCCESS, types.ADMIN__UPDATE_CHAT_OPTIONS_FAILURE],
		uri: '/api/admin/chatOptions',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(requestData),
		},
		payload: { requestData },
	});
}

export function addPolicyToUser(body) {
	return api({
		types: [types.ADMIN__ADD_POLICY_TO_USER_REQUEST, types.ADMIN__ADD_POLICY_TO_USER_SUCCESS, types.ADMIN__ADD_POLICY_TO_USER_FAILURE],
		uri: '/api/admin/addPolicy',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function fetchChatOptions() {
	return api({
		types: [types.ADMIN__FETCH_CHAT_OPTIONS_REQUEST, types.ADMIN__FETCH_CHAT_OPTIONS_SUCCESS, types.ADMIN__FETCH_CHAT_OPTIONS_FAILURE],
		uri: '/api/admin/chatOptions',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
		},
	});
}
export function removePolicyFromUser(body) {
	return api({
		types: [types.ADMIN__REMOVE_POLICY_FROM_USER_REQUEST, types.ADMIN__REMOVE_POLICY_FROM_USER_SUCCESS, types.ADMIN__REMOVE_POLICY_FROM_USER_FAILURE],
		uri: '/api/admin/removePolicy',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { ...body },
	});
}

export function fetchUpdatedUser(userId) {
	return api({
		types: [types.ADMIN__FETCH_UPDATED_USER_REQUEST, types.ADMIN__FETCH_UPDATED_USER_SUCCESS, types.ADMIN__FETCH_UPDATED_USER_FAILURE],
		uri: `/api/admin/fetchUser`,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ userId }),
		},
		payload: { userId },
	});
}

export function adminSendPasswordReset(userId) {
	return api({
		types: [types.ADMIN__SEND_PASSWORD_RESET_REQUEST, types.ADMIN__SEND_PASSWORD_RESET_SUCCESS, types.ADMIN__SEND_PASSWORD_RESET_FAILURE],
		uri: '/api/admin/sendPasswordReset',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ userId }),
		},
		payload: { userId },
	});
}

export function adminSendEmailConfirmation(userId) {
	return api({
		types: [types.ADMIN__SEND_EMAIL_CONFIRMATION_REQUEST, types.ADMIN__SEND_EMAIL_CONFIRMATION_SUCCESS, types.ADMIN__SEND_EMAIL_CONFIRMATION_FAILURE],
		uri: '/api/admin/sendEmailConfirmation',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ userId }),
		},
		payload: { userId },
	});
}
export function adminDeleteUser(user) {
	return api({
		types: [types.ADMIN__DELETE_USER_REQUEST, types.ADMIN__DELETE_USER_SUCCESS, types.ADMIN__DELETE_USER_FAILURE],
		uri: '/api/admin/deleteuser',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(user),
		},
		payload: { user },
	});
}

export function adminCreateUser(email) {
	return api({
		types: [types.ADMIN__CREATE_USER_REQUEST, types.ADMIN__CREATE_USER_SUCCESS, types.ADMIN__CREATE_USER_FAILURE],
		uri: '/api/admin/createuser',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email }),
		},
		payload: { email },
	});
}

export function adminGetImportStatus() {
	return api({
		types: [types.ADMIN__GET_IMPORT_STATUS_REQUEST, types.ADMIN__GET_IMPORT_STATUS_SUCCESS, types.ADMIN__GET_IMPORT_STATUS_FAILURE],
		uri: '/api/admin/importusers',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
	});
}

export function adminChangeEmail(body) {
	return api({
		types: [types.ADMIN__CHANGE_USER_EMAIL_REQUEST, types.ADMIN__CHANGE_USER_EMAIL_SUCCESS, types.ADMIN__CHANGE_USER_EMAIL_FAILURE],
		uri: '/api/admin/changemail',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function adminUpdateDeliveryTester(body) {
	return api({
		types: [types.ADMIN__UPDATE_DELIVERY_TESTER_REQUEST, types.ADMIN__UPDATE_DELIVERY_TESTER_SUCCESS, types.ADMIN__UPDATE_DELIVERY_TESTER_FAILURE],
		uri: '/api/admin/updatedeliverytester',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: body,
	});
}

export function adminBulkUpdateEDeliveryNotifications(updateCount) {
	return api({
		types: [types.ADMIN__UPDATE_CLAIMS_DELIVERY_REQUEST, types.ADMIN__UPDATE_CLAIMS_DELIVERY_SUCCESS, types.ADMIN__UPDATE_CLAIMS_DELIVERY_FAILURE],
		uri: '/api/admin/bulkUpdateEDeliveryNotifications',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ updateCount }),
		},
		payload: { updateCount },
	});
}

export function getEDeliveryDiscrepancies() {
	return api({
		types: [types.ADMIN__UPDATE_CLAIMS_DELIVERY_REQUEST, types.ADMIN__UPDATE_CLAIMS_DELIVERY_SUCCESS, types.ADMIN__UPDATE_CLAIMS_DELIVERY_FAILURE],
		uri: '/api/admin/getEDeliveryDiscrepancies',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			// body: JSON.stringify( body)
		},
		// payload: body
	});
}

export function adminGetSystemToggles() {
	return api({
		types: [types.ADMIN__GET_SYSTEM_TOGGLES_REQUEST, types.ADMIN__GET_SYSTEM_TOGGLES_SUCCESS, types.ADMIN__GET_SYSTEM_TOGGLES_FAILURE],
		uri: '/api/admin/systemtoggles',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
	});
}

export function adminUpdateSystemToggles(toggle) {
	return api({
		types: [types.ADMIN__UPDATE_SYSTEM_TOGGLES_REQUEST, types.ADMIN__UPDATE_SYSTEM_TOGGLES_SUCCESS, types.ADMIN__UPDATE_SYSTEM_TOGGLES_FAILURE],
		uri: '/api/admin/systemtoggles',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(toggle),
		},
		payload: { toggle },
	});
}

export function adminImportUsers(file) {
	return (dispatch, getState) => {
		const url = `/api/admin/importusers`;
		dispatch({ type: types.ADMIN__IMPORT_USERS_REQUEST });
		const formData = new FormData();

		formData.append('file', file);

		const payload = { formData };

		return fetch(url, {
			method: 'POST',
			headers: {
				AUTHORIZATION: `Bearer ${getState().session.token}`,
			},
			body: formData,
		})
			.then(
				(response) => response.json(),
				(error) => {
					dispatch({ payload: { formData }, error, type: types.ADMIN__IMPORT_USERS_FAILURE });
					throw error;
				}
			)
			.then(
				(response) => {
					if (response.success === undefined) return dispatch({ ...payload, response, type: types.ADMIN__IMPORT_USERS_SUCCESS });
					if (response.success) return dispatch({ payload, response: response.result, type: types.ADMIN__IMPORT_USERS_SUCCESS });
					dispatch({ payload, error: response.errors, type: types.ADMIN__IMPORT_USERS_FAILURE });
					throw new Error(response.errors.length > 0 ? response.errors[0] : 'Api returned an error response', response.errors);
				},
				(error) => {
					dispatch({ payload, error, type: types.ADMIN__IMPORT_USERS_FAILURE });
					throw error;
				}
			);
	};
}

export function getActiveUsers(date) {
	return api({
		types: [types.ADMIN__GET_ACTIVE_USERS_REQUEST, types.ADMIN__GET_ACTIVE_USERS_SUCCESS, types.ADMIN__GET_ACTIVE_USERS_FAILURE],
		uri: `/api/admin/activeUsers${date ? `?date=${moment(date).format()}` : ''}`,
		shouldCallAPI: () => true,
		config: {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
	});
}

export function getAllLogFiles() {
	return api({
		types: [types.ADMIN__GET_ALL_LOG_FILES_REQUEST, types.ADMIN__GET_ALL_LOG_FILES_SUCCESS, types.ADMIN__GET_ALL_LOG_FILES_FAILURE],
		uri: '/api/admin/logfiles',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
	});
}

export function getAllAdvertisements() {
	return api({
		types: [types.ADMIN__ADVERTISEMENTS_GETALL_REQUEST, types.ADMIN__ADVERTISEMENTS_GETALL_SUCCESS, types.ADMIN__ADVERTISEMENTS_GETALL_FAILURE],
		uri: '/api/admin/advertisement',
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		},
	});
}

export function addAdvertisement(ad) {
	return api({
		types: [types.ADMIN__ADVERTISEMENTS_ADD_REQUEST, types.ADMIN__ADVERTISEMENTS_ADD_SUCCESS, types.ADMIN__ADVERTISEMENTS_ADD_FAILURE],
		uri: '/api/admin/advertisement',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(ad),
		},
		payload: { ad },
	});
}

export function updateAdvertisement(ad) {
	return api({
		types: [types.ADMIN__ADVERTISEMENTS_UPDATE_REQUEST, types.ADMIN__ADVERTISEMENTS_UPDATE_SUCCESS, types.ADMIN__ADVERTISEMENTS_UPDATE_FAILURE],
		uri: `/api/admin/advertisement/${ad.id}`,
		shouldCallAPI: () => true,
		config: {
			method: 'put',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(ad),
		},
		payload: { ad },
	});
}

export function removeAdvertisement(id) {
	return api({
		types: [types.ADMIN__ADVERTISEMENTS_REMOVE_REQUEST, types.ADMIN__ADVERTISEMENTS_REMOVE_SUCCESS, types.ADMIN__ADVERTISEMENTS_REMOVE_FAILURE],
		uri: `/api/admin/advertisement/${id}`,
		shouldCallAPI: () => true,
		config: {
			method: 'delete',
		},
	});
}

export function resetAdvertisement() {
	return api({
		types: [types.ADMIN__ADVERTISEMENTS__RESET_REQUEST , types.ADMIN__ADVERTISEMENTS__RESET_SUCCESS, types.ADMIN__ADVERTISEMENTS__RESET_FAILURE],
		uri: '/api/admin/advertisement/reset',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
			   'Accept': 'application/json',
			   'Content-Type': 'application/json'
			},
		},
	});
}